import React, { useState } from 'react'
import LLMResultsDisplay from './LLMResultsDisplay'
import endpoints from '../endpoints.json'
import './Evaluate.css'

const Evaluate = () => {
  const [selectedOption1, setSelectedOption1] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [selectedOption2, setSelectedOption2] = useState('')
  const [resultsData, setResultsData] = useState(null)
  const [loading, setLoading] = useState(false) // State for loader

  const handleOption1Change = (event) => {
    setSelectedOption1(event.target.value)
  }

  const handleInputChange = (event) => {
    setInputValue(event.target.value)
  }

  const handleOption2Change = (event) => {
    setSelectedOption2(event.target.value)
  }

  const handleClick = async () => {
    setLoading(true) // Show loader
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/evaluate`, {
      department: selectedOption1,
      topk: inputValue,
      type: selectedOption2
    })
    //const response = { results: data_test }
    console.log('Response:', response)
    setResultsData(response) // Assuming the response contains the data in response.data
    setLoading(false) // Hide loader
  }

  return (
    <div>
      <div className="header">
        {/* Icon and title in the upper right corner */}
        <img
          className="stratsys-search-logo"
          src="https://frontend-packages.svc.stratsys.com/logos/icon-dark.svg"
          alt="Stratsys Icon"
        />
        <div class="one-ux-typography--heading-500">
          <one-ux-text>AI Evaluation</one-ux-text>
        </div>
      </div>
      <div className="evaluate-container">
        <label className="evaluate-label">
          Department:
          <select className="evaluate-select" value={selectedOption1} onChange={handleOption1Change}>
            <option value="Support">Support</option>
            <option value="People">People</option>
          </select>
        </label>
        <br />
        <label className="evaluate-label">
          Topk:
          <input className="evaluate-input" type="text" value={inputValue} onChange={handleInputChange} />
        </label>
        <br />
        <label className="evaluate-label">
          Type:
          <select className="evaluate-select" value={selectedOption2} onChange={handleOption2Change}>
            <option value="rating">Rating</option>
            <option value="lying">Lying</option>
            <option value="dontknow">Dont know</option>
          </select>
        </label>
        <br />
        <button className="evaluate-button" onClick={handleClick}>
          Evaluate
        </button>
      </div>
      {loading && <div className="loader"></div>} {/* Loader */}
      {resultsData && <LLMResultsDisplay data={resultsData} />}
    </div>
  )
}

export default Evaluate
